import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { companyInfo, serviceGroups } from "../data/siteData";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div>
          <p className="section-eyebrow">Touchmark Limited</p>
          <h3>Built for homes, estates, offices and demanding site conditions.</h3>
          <p>
            {companyInfo.name} delivers fabricated metal solutions that combine
            structural confidence with a polished final look.
          </p>
        </div>

        <div>
          <h4>Quick links</h4>
          <div className="site-footer__links">
            <Link to="/services">Services</Link>
            <Link to="/projects">Projects</Link>
            <Link to="/about">About</Link>
            <Link to="/gallery">Gallery</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>

        <div>
          <h4>Core work</h4>
          <ul className="site-footer__list">
            {serviceGroups.slice(0, 4).map((service) => (
              <li key={service.title}>{service.title}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4>Contact</h4>
          <div className="site-footer__links">
            <a href={`tel:${companyInfo.phonePrimary}`}>{companyInfo.phonePrimaryIntl}</a>
            <a href={`tel:${companyInfo.phoneSecondary}`}>{companyInfo.phoneSecondaryIntl}</a>
            <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
            <a href={companyInfo.whatsappLink} target="_blank" rel="noreferrer">
              WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        <p>
          © {year} {companyInfo.name}. {companyInfo.rcNumber}. All rights reserved.
        </p>
        <p>{companyInfo.serviceArea}</p>
      </div>
    </footer>
  );
}

export default Footer;
